import React from 'react'
import Modal from '@/v2/components/common/Modal'
import AppointmentInformation from './AppointmentInformation'
import Patient from './Patient'
import { Wrapper } from './styles'
import useAppointment from '@/v2/hooks/useAppointment'
import { Skeleton } from '@mui/material'
import RTAppointments from '@/v2/hooks/subscriptions/messages/RTAppointments'
import { usePatientOfficeNotes } from '@/v2/hooks/patient/usePatientNotes'

const Details = ({ isOpen, onClose, onEdit, onCancel, ...props }) => {
  const { id } = props
  const { appointment, loading } = useAppointment({
    appointmentId: id,
  })
  const patientId = appointment?.patient?.id
  const { notes } = usePatientOfficeNotes(patientId)
  const alertNotes = notes?.filter(note => note?.alerts)

  return (
    <Modal
      isOpen={isOpen}
      showClose={false}
      showConfirm={false}
      onConfirm={() => {}}
      onClose={onClose}
      title="Appointment info"
      maxWidth={false}
    >
      <RTAppointments appointmentId={id} />
      {loading ? (
        <Wrapper>
          <Skeleton variant="rectangular" width={295} height={300} />
          <Skeleton variant="rectangular" width={295} height={300} />
        </Wrapper>
      ) : (
        <Wrapper>
          <AppointmentInformation
            appointment={appointment}
            alertNotes={alertNotes}
            onEdit={onEdit}
            onCancel={onCancel}
          />
          <Patient patient={appointment?.patient} appointment={appointment} />
        </Wrapper>
      )}
    </Modal>
  )
}

export default Details
